<template>
	<div class="registrierung">
		<h1>Registrierung</h1>
		<p>Wir begr&uuml;&szlig;en Sie herzlich auf der Plattform des Projekts AVENUE. Auf dieser Plattform k&ouml;nnen Sie Ihre eigene Arbeitsdichte anhand eines Fragebogens einsch&auml;tzen und Sie erhalten eine Auswertung und Interpretation der Ergebnisse.</p>
		<h2>Erhebung von Daten</h2>
		<p>Auf dieser Plattform beantworten Sie einen Fragebogen, der sich auf verschiedene Aspekte des Erlebens und Verhaltens am Arbeitsplatz bezieht. Am Ende des Fragebogens bitten wir Sie um demographische Angaben. Die erhobenen Daten werden gespeichert und Ihnen in Form eines Ergebnisberichts zur Verf&uuml;gung gestellt sowie f&uuml;r eine Benchmarkstudie verwendet. Alle Angaben, die Sie in dieser Befragung machen, werden streng vertraulich behandelt und ausschlie&szlig;lich in aggregierter Form ver&ouml;ffentlicht, so dass keinerlei R&uuml;ckschl&uuml;sse auf einzelne Personen gezogen werden k&ouml;nnen. Im Rahmen dieser Untersuchung werden keine personenbezogenen Daten erhoben.</p>
		<p>Die Teilnahme an dieser Untersuchung ist freiwillig und Sie k&ouml;nnen die Teilnahme an der Untersuchung jederzeit abbrechen, ohne dass Ihnen dadurch irgendwelche Nachteile entstehen.</p>
		<p>Die Daten werden auf einem Server des Lehrstuhls f&uuml;r Psychologie, insbes. Wirtschafts- und Sozialpsychologie an der Friedrich-Alexander-Universit&auml;t Erlangen-N&uuml;rnberg gespeichert.</p>
		<p><router-link to="/datenschutz">Datenschutzerkl&auml;rung des Lehrstuhls f&uuml;r Psychologie, insbes. Wirtschafts- und Sozialpsychologie.</router-link></p>
		<h2>Einwilligungserkl&auml;rung</h2>
		<p><v-checkbox v-model="einwilligung" label="Hiermit bestätige ich, dass ich die oben aufgeführten Informationen und Hinweise gelesen habe und damit einverstanden bin."></v-checkbox></p>
		<div v-show="einwilligung">
			<h2>Kennung</h2>
			<p>Damit Sie sp&auml;ter Ihre Ergebnisse einsehen k&ouml;nnen und die Plattform f&uuml;r eine wiederholte Einsch&auml;tzung Ihrer Arbeitsdichte nutzen k&ouml;nnen, wurde eine anonyme Kennung erstellt. Diese Kennung besteht aus einer zuf&auml;lligen Zeichenfolge, die keine R&uuml;ckschl&uuml;sse auf Ihre Person zul&auml;sst. Im unten stehenden Feld k&ouml;nnen Sie diese Kennung ver&auml;ndern bzw. eine eigene Kennung verwenden. Die eingegebene Kennung wird auf Duplikate &uuml;berpr&uuml;ft.</p>
			<p>Die Kennung muss mindestens acht Zeichen enthalten und darf Buchstaben wie auch Ziffern umfassen; Sonderzeichen sind nicht erlaubt.</p>
			<p><v-text-field id="kennung" label="Kennung" v-model="kennung" :error-messages="errors" :background-color="kennungFarbe" prepend-inner-icon="mdi-fingerprint"></v-text-field></p>
			<p><v-btn v-bind:disabled="kennungSperre" @click="kennungSpeichern(kennung)">Registrierung abschlie&szlig;en</v-btn></p>
			<merkzettel v-show="!kennungSperre" :kennung="kennung"></merkzettel>
		</div>
	</div>
</template>
<script>
	import axios from 'axios';
	import merkzettel from '../components/merkzettel.vue'
	export default {
		name: 'registrierung',
		components: {
			merkzettel
		},
		props: {
			fragebogenSeiten: {
				type: JSON
			},
			fragebogenGruppe: {
				type: JSON
			}
		},
		data: function () {
			return {
				// teilnehmer: String,
				demographieAntworten: {},
				kennung: String,
				pruefung: String,
				kennungFarbe: '#ffffff',
				errors: [],
				einwilligung: false,
				kennungSperre: true
			}
		},
		mounted() {
			this.kennung = this.zufallskennung();
			// this.$teilnehmer = 'j874y0asdsadsad';
			console.log('Registrierung ############');			
			console.log('Parameter e: ' + this.$route.query.e);
			console.log('Parameter b: ' + this.$route.query.b);
		},
		methods: {
			zufallskennung: function(laenge, zeichen) {
				laenge = laenge || 16;
				zeichen = zeichen || '0123456789abcdefghijkmnopqrstuvwxyz';
				var zeichenfolge = '';
				for (var i = 0; i < laenge; i++) {
					var position = Math.floor(Math.random() * zeichen.length);
					zeichenfolge += zeichen.substring(position,position+1);
				}
				return zeichenfolge;
			},
			kennungSpeichern: function(kennung) {
				this.teilnehmer = kennung;
				/* Teilnehmer im store speichern */
				this.setTeilnehmer(kennung);
				/* Der Teilnehmer wird bereits jetzt auf der Plattform hinterlegt, damit die Kennung vergeben ist */
				axios.post('https://www.arbeitsverdichtung.de/api/demographie', {
					teilnehmer: this.teilnehmer
				})
				.then(response => {
					console.log(response);
					if (this.$route.query.e) {
						this.$router.push({
							path: '/fragebogen', 
							query: {
								e: this.$route.query.e,
								b: this.$route.query.b
							}
						});
					} else {
						this.$router.push({name: 'Home'});
					}
				})
				.catch(error => {
					console.log(error);
				});
			},
			setTeilnehmer(kennung) {
				this.$store.dispatch('setTeilnehmer', kennung);
				this.$store.dispatch('getLesezeichenListe');
			}
		},
		watch: {
			async kennung(kennung) {
				this.kennungFarbe = '#ffffff';
				this.kennungSperre = true;
				var sonderzeichen = /[^a-zA-Z0-9]/;
				if (kennung.length == 0) {
					this.errors = ['Die Teilnehmerkennung darf nicht leer sein!'];
					this.kennungFarbe = '#ffeeee';
					this.kennungSperre = true;
				}
				else if (kennung.length < 8) {
					this.errors = ['Die Teilnehmerkennung muss acht oder mehr Zeichen umfassen!'];
					this.kennungFarbe = '#ffeeee';
					this.kennungSperre = true;
				}
				else if (kennung.length > 16) {
					this.errors = ['Die Teilnehmerkennung darf nicht mehr als 16 Zeichen umfassen!'];
					this.kennungFarbe = '#ffeeee';
					this.kennungSperre = true;
				}
				else if (kennung.indexOf(" ") !== -1) {
					this.errors = ['In der Teilnehmerkennung sind keine Leerzeichen erlaubt!'];
					this.kennungFarbe = '#ffeeee';
					this.kennungSperre = true;
				}
				else if (sonderzeichen.test(kennung) == true) {
					this.errors = ['Die Teilnehmerkennung darf nur Buchstaben und Ziffern enthalten; Sonderzeichen sind nicht erlaubt!'];
					this.kennungFarbe = '#ffeeee';
					this.kennungSperre = true;
				}
				else if (kennung.indexOf(" ") !== -1) {
					this.errors = ['In der Teilnehmerkennung sind keine Leerzeichen erlaubt!'];
					this.kennungFarbe = '#ffeeee';
					this.kennungSperre = true;
				}
				else {
					this.errors = ['Überprüfung auf Duplikate läuft...'];
					try {
						const response = await axios.get('https://www.arbeitsverdichtung.de/api/kennung', {
							params: {
								kennung: kennung
							}
						});
						const data = await response;
						if (Number.parseInt(data.data) == 0) {
							// return true;
							this.errors = [];
							this.kennungFarbe = '#eeffee';
							this.kennungSperre = false;
						} else {
							this.errors = ['Die Kennung ist bereits vorhanden!'];
							this.kennungFarbe = '#ffeeee';
							this.kennungSperre = true;
						}
					} catch (error) {
						alert(error);
					}
				}
			}
		}
	}
</script>
<style scoped>
	#kennung {
		font-size: 1.5em;
	}
</style>
